import { ONE } from '@morpho-org/dapp-core';
import { vaultKey } from '@repo/web3/utils';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useWeb3Context } from '@/contexts/Web3Context';
import { userEarnPositionsQueryOptions } from '@/hooks/positions/userEarnPositionsQuery';

/**
 * The connected user's earn (vault) positions. Shares its query with the server-side prefetch in
 * `TableVault.server`, so the first client render gets a hydration cache hit.
 *
 * @returns A Set of `vaultKey` composite keys identifying
 * vaults with an active position (V1 or V2).
 */
export function useUserVaultPositions(): Set<string> {
  const {
    account
  } = useWeb3Context();
  const {
    data
  } = useQuery(userEarnPositionsQueryOptions(account.address));
  return useMemo(() => {
    const keys = new Set<string>();
    if (!account.address || !data?.items) return keys;
    for (const position of data.items) {
      if (BigInt(position.shares) >= ONE) {
        keys.add(vaultKey(position.vault));
      }
    }
    return keys;
  }, [account.address, data?.items]);
}